<div class="d-flex justify-flex-end">
   <div class="dropdown">
      <button class="dropbtn">
         <i class="fa fa-download"></i> {{ 'general.export_data' | translate }}
      </button>
      <div class="dropdown-content">
         <a (click)="exportToExcel()">{{ 'general.export_as_excel' | translate }} (.xlsx)</a>
         <a (click)="exportToPDF()">{{ 'general.export_as_pdf' | translate }}</a>
         <a (click)="exportToCSV()">{{ 'general.export_as_csv' | translate }}</a>
      </div>
   </div>
</div>
<br>
<main>
   <div class="scroll white-bg border">
      <div *ngIf="
            !(
               this.courses?.totalSubjects == 0 &&
               name == undefined &&
               generation == -1 &&
               departmentId == -1 &&
               professorId == '-1' &&
               status == '-1' &&
               type == -1 &&
               facultyId == '-1'
            )
         " class="filter-bar">
         <div class="filter-controls">
            <h4 class="filter-title">{{ 'general.subjects' | translate }}</h4>

            <div class="filter-right-section">
               <div class="filter-group">
                  <label for="generation">{{ 'app.select_academic_year' | translate }}</label>
                  <select id="generation" class="filter-select" [(ngModel)]="generation" (change)="filterCourses()">
                     <option value="-1" selected>{{ 'general.all' | translate }}</option>
                     <option value="g2021">2020/2021</option>
                     <option value="g2122">2021/2022</option>
                     <option value="g2223">2022/2023</option>
                     <option value="g2324">2023/2024</option>
                     <option value="g2425">2024/2025</option>
                     <option value="g2526">2025/2026</option>
                     <option value="g2627">2027/2028</option>
                  </select>
               </div>

               <div class="filter-group">
                  <label for="professor">{{ 'app.filter_by_educator' | translate }}</label>
                  <select id="professor" class="filter-select" [(ngModel)]="professorId" (change)="filterCourses()">
                     <option value="-1" selected>{{ 'general.all' | translate }}</option>
                     <ng-container *ngFor="let professor of this.professors">
                        <option value="{{ professor.id }}">
                           {{ professor.name }}
                        </option>
                     </ng-container>
                  </select>
               </div>

               <div class="filter-group">
                  <label for="status">{{ 'app.select_status_to_filter' | translate }}</label>
                  <select id="status" class="filter-select" [(ngModel)]="status" (change)="filterCourses()">
                     <option value="-1" selected>{{ 'general.all' | translate }}</option>
                     <option value="1">{{ 'general.active' | translate }}</option>
                     <option value="0">{{ 'general.deactive' | translate }}</option>
                  </select>
               </div>

               <div class="filter-group">
                  <label for="subjectName">{{ 'placeholders.search_by_name' | translate }}</label>
                  <div class="input-with-icon">
                     <img src="assets/images/icons/search.png" alt="search" />
                     <input id="subjectName" type="text" class="filter-input" [(ngModel)]="name"
                        (ngModelChange)="titleFilter()" />
                  </div>
               </div>

               <div class="filter-group">
                  <label>&nbsp;</label>
                  <button class="reset-btn" (click)="resetFilter()" aria-label="Reset filters">
                     <div class="reset-icon-wrapper">
                        <img src="assets/images/icons/refresh.png" alt="Reset" />
                     </div>
                  </button>
               </div>
            </div>
         </div>
      </div>
      <div *ngIf="this.courses?.totalSubjects != 0" class="scroll" #contentToCapture>
         <!-- Custom Templates for app-table -->
         <ng-template #typeTemplate let-row>
            <ng-container *ngIf="row.type === 1">
               {{ 'general.mandatory' | translate }}
            </ng-container>
            <ng-container *ngIf="row.type === 2">
               {{ 'general.elective' | translate }}
            </ng-container>
         </ng-template>

         <ng-template #statusTemplate let-row>
            <ng-container *ngIf="row.status">
               {{ 'general.active' | translate }}
            </ng-container>
            <ng-container *ngIf="!row.status">
               {{ 'general.deactive' | translate }}
            </ng-container>
         </ng-template>

         <ng-template #editTemplate let-row>
            <button class="btn-blue-borderless-md" (click)="openModal(row.id)">
               <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_733_18913)">
                     <path
                        d="M7.33301 2.66669H2.66634C2.31272 2.66669 1.97358 2.80716 1.72353 3.05721C1.47348 3.30726 1.33301 3.6464 1.33301 4.00002V13.3334C1.33301 13.687 1.47348 14.0261 1.72353 14.2762C1.97358 14.5262 2.31272 14.6667 2.66634 14.6667H11.9997C12.3533 14.6667 12.6924 14.5262 12.9425 14.2762C13.1925 14.0261 13.333 13.687 13.333 13.3334V8.66669"
                        stroke="#004080" stroke-width="1.46087" stroke-linecap="round" stroke-linejoin="round" />
                     <path
                        d="M12.3335 1.66665C12.5987 1.40144 12.9584 1.25244 13.3335 1.25244C13.7086 1.25244 14.0683 1.40144 14.3335 1.66665C14.5987 1.93187 14.7477 2.29158 14.7477 2.66665C14.7477 3.04173 14.5987 3.40144 14.3335 3.66665L8.00016 9.99999L5.3335 10.6667L6.00016 7.99999L12.3335 1.66665Z"
                        stroke="#004080" stroke-width="1.46087" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                     <clipPath id="clip0_733_18913">
                        <rect width="16" height="16" fill="white" />
                     </clipPath>
                  </defs>
               </svg>
               {{ 'general.edit' | translate }}
            </button>
         </ng-template>

         <!-- App Table Component -->
         <app-table [columns]="columns" [data]="tableData" [paginatedData]="tableData | paginate: {
               itemsPerPage: pageSize,
               currentPage: page,
               totalItems: this.courses?.totalSubjects
            }" [customTemplates]="{
               typeTemplate: typeTemplate,
               statusTemplate: statusTemplate,
               editTemplate: editTemplate
            }" [hasCheckboxes]="false">
         </app-table>
      </div>
      <div class="zeroState" *ngIf="
            this.courses?.totalSubjects == 0 &&
            (name != undefined ||
               facultyId != '-1' ||
               generation != -1 ||
               departmentId != -1 ||
               professorId != '-1' ||
               status != '-1' ||
               type != -1)
         ">
         {{ 'new_entries.no_subjects_found' | translate }}
      </div>
      <div class="zero-state" *ngIf="
            this.courses?.totalSubjects == 0 &&
            name == undefined &&
            facultyId == '-1' &&
            generation == -1 &&
            departmentId == -1 &&
            professorId == '-1' &&
            status == '-1' &&
            type == -1
         ">
         <!-- <img src="../../assets/images/icona-image.png" alt="" /> -->
         <h5 class="bold">
            {{ 'app.there_are_no_subjects_registered_in_your_instutition' | translate }} yet.<br /><span
               class="clickable" routerLink="/administrator/register-module/course-register">{{ 'general.click_here' |
               translate }}</span>
            to begin registering subjects.
         </h5>
      </div>

      <div class="paginationContainer">
         <div *ngIf="this.courses?.totalSubjects != 0">
            <!-- <button class="clone" (click)="openGenerationChangeModal()">
               <i class="fas fa-copy mr-5"></i>{{ 'app.subject.subject_wizard' | translate }}
            </button> -->
         </div>
         <pagination-controls *ngIf="this.courses?.totalSubjects != 0" class="num" (pageChange)="changePage($event)"
            responsive="true" previousLabel="" nextLabel=""></pagination-controls>
         <!-- <div>
         <button class="reportBtn" (click)="registerSubjectModal()">
            <i class="fas fa-plus mr-5"></i>{{ 'app.register_subjects' | translate }}
         </button>
      </div> -->
      </div>
   </div>
</main>